export default __webpack_public_path__ + "static/media/successDot.be9cfe20.svg";